import { Component, inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormLabelComponent,
} from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    NzFormControlComponent,
    NzInputModule,
    NzFormItemComponent,
    NzButtonComponent,
    NzFormLabelComponent,
    AngularSvgIconModule,
    NzToolTipModule,
    NzSelectModule,
    NzIconModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './forgot-password.component.html',
  providers: [NzMessageService],
})
export class ForgotPasswordComponent implements OnDestroy {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly destroy$ = new Subject<void>();
  private readonly commonService = inject(CommonService);

  isLoading = false;
  errorMessage = '';

  readonly forgotPasswordForm: FormGroup = this.fb.group({
    email: [
      '',
      [
        Validators.required,
        Validators.email,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
      ],
    ],
  });

  submitForm(): void {
    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      const email = this.forgotPasswordForm.get('email')?.value;

      this.authService
        .forgotPassword(email)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.commonService.notify(
              'success',
              'Password reset email sent successfully'
            );
            this.forgotPasswordForm.reset();
          },
          error: (error: Error) => {
            this.isLoading = false;
            this.errorMessage = error.message;
            setTimeout(() => {
              this.errorMessage = '';
            }, 3000);
          },
          complete: () => {
            this.isLoading = false;
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
